import React from "react";
import {
  Route,
  Navigate,
  RouteProps,
} from "react-router-dom";

import { APICore } from "../helpers/api/apiCore";
import { USER_ROLE } from "constants/index";

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ component: Component, roles, ...rest }: any) => {
  const api = new APICore();

  return (
    <Route
      {...rest}
      render={(props: RouteProps) => {
        if (api.isUserAuthenticated() === false) {
          // not logged in so redirect to login page with the return url
          return (
            <Navigate
              to={{
                pathname: "/auth/login",
                // state: { from: props["location"] },
              }}
            />
          );
        }

        const loggedInUser = api.getLoggedInUser();

        if((loggedInUser.RoleName === USER_ROLE.VENDOR) && (!loggedInUser.IsProfileCompleted)) {
            return <Navigate to={{ pathname: "/vendor-profile-setup" }} />;
          }
        // check if route is restricted by role
        if (roles && roles.indexOf(loggedInUser.RoleName) === -1) {
          // role not authorised so redirect to home page
          return <Navigate to={{ pathname: "/" }} />;
        }
        // authorised so return component
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
